import { render, staticRenderFns } from "./TextDlg.vue?vue&type=template&id=01c38ed6&scoped=true"
import script from "./TextDlg.vue?vue&type=script&lang=js"
export * from "./TextDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c38ed6",
  null
  
)

export default component.exports